
<template>
    <div class="x_box">
        <b-breadcrumb class="x_breadcrumb" :items="crumbs"></b-breadcrumb>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/customer/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item">{{ $t('customer_list') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <button type="button" class="btn btn-default" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped no-bor table-scroll">
                        <thead>
                            <tr>
                                <th class="text-center width-column">{{ $t('no') }}</th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Code')">{{ $t('code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Name')">{{ $t('khmer_name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('NameEng')">{{ $t('latin_name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('CustomerTypeName')">{{ $t('customer_type') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('EmployeeName')">{{ $t('sale_reputation') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Phone')">{{ $t('phone') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field width-column" @click="onSort('Email')">{{ $t('email') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">{{ $t('point') }}</th>
                                <th class="sorting">{{ $t('address') }}</th>
                                <th style="width: 22px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'customer_edit', params:{id:ret.Id}}">{{ret.Code}}</router-link></td>
                                <td>{{ret.Name}}</td>
                                <td>{{ret.NameEng}}</td>
                                <td>{{ret.CustomerTypeName}}</td>
                                <td>{{ret.EmployeeName}}</td>
                                <td>{{ret.Phone}}</td>
                                <td>{{ret.Email}}</td>
                                <td>{{ret.Point}}</td>
                                <td>{{ret.Address}}</td>
                                <td>
                                    <button type="button" class="btn btn-danger btn-table-xs btn-delete" @click="onDelete(ret.Id)"><i class="fa fa-times" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="mt-3">
                        <span>{{$t('total_record')}}: {{query.Total}}</span>
                        <div class="pull-right">
                            <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                            hide-goto-end-buttons
                            @change="paging($event)"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
export default {
    data: function(){
        return {
            query:{
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                SortType: '',
                SortField: ''
            },
            records:[],
            viewType: 0,
            crumbs: [
                { text: this.$t('home'), href: '/' },
                { text: this.$t('customer_list'), active: true }
            ]
        }
    },
    created: function(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('customer/list', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function() { loading.hide(); });
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        viewTypeChange(n){
            this.viewType = n;
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        },
        onDelete(id){
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.value) {
                    this.$api().post('customer/delete', { Id: id }).then(res => {
                        if(this.$isValid(res)){
                            this.toList();
                            Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
                        }
                    });
                }
            });
        }
    }
}
</script>
